import React from 'react';
import { getGamemodeColor } from '../lib/gamemode.js';

type BadgeVariant = 'gamemode' | 'difficulty' | 'rank' | 'neutral';

interface BadgeProps {
  variant?: BadgeVariant;
  gamemode?: string;
  children: React.ReactNode;
  className?: string;
}

export default function Badge({
  variant = 'neutral',
  gamemode,
  children,
  className = ''
}: BadgeProps) {
  let colorClass = 'bg-white/5 border border-white/10 text-on-surface-variant';

  if (variant === 'gamemode' && gamemode) {
    colorClass = getGamemodeColor(gamemode);
  } else if (variant === 'difficulty') {
    const label = String(children).toLowerCase();
    colorClass =
      label === 'beginner'
        ? 'bg-[rgba(76,175,80,0.15)] text-[#4caf50]'
        : 'bg-[rgba(255,191,0,0.15)] text-[#ffbf00]';
  } else if (variant === 'rank') {
    colorClass = 'bg-error/15 text-error';
  }

  return (
    <span
      className={`inline-block px-2 py-0.5 rounded-[4px] text-[10px] font-bold uppercase tracking-tighter font-label-caps ${colorClass} ${className}`}
    >
      {children}
    </span>
  );
}
